import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CreatorType } from '@pixacare/domain';
import { phoneNumberRegexValidator } from '@shared/validators/phone-number-regex-validator';
import { environment } from 'src/environments/environment';

export const validateDepartmentIds =
  (form: FormGroup): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    const clientCode = form.get('clientCode').value;

    // we can select 0 departments for common client
    if (clientCode === environment.commonClientCode) {
      return null;
    }

    // we must select at least 1 department for other clients
    const departmentIds = control.value as number[];
    if (!departmentIds || departmentIds.length === 0) {
      return { departmentRequired: true };
    }
    return null;
  };

export const validatePatientContact =
  (form: FormGroup, phoneNumberRegex: string): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    // if created for the user / IDEL, we don't need to validate the patient contact
    if (form.get('creatorType').value === CreatorType.BY_USER) {
      return null;
    }

    // if created for the patient, we must select a patient contact
    const phoneNumber = control.value?.phoneNumber as string | null;
    if (!phoneNumber) {
      return { required: true };
    }

    const validator = phoneNumberRegexValidator(phoneNumberRegex);
    return validator(new FormControl(phoneNumber));
  };

export const validatePatientForm =
  (form: FormGroup): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    // if reated for the user / IDEL, we don't need to validate the patient form
    if (form.get('creatorType').value === CreatorType.BY_USER) {
      return null;
    }

    // if created for the patient, we must select a patient form
    const patientForm = control.value;
    if (!patientForm) {
      return { required: true };
    }

    return null;
  };

export const validateLocaleCode =
  (form: FormGroup): ValidatorFn =>
  (): ValidationErrors | null => {
    if (form.get('creatorType').value === CreatorType.BY_USER) {
      return null;
    }

    const localeCode = form.get('localeCode').value as string | null;
    if (!localeCode) {
      return { required: true };
    }

    return null;
  };
